(() => {
  function init() {
    const root = document.getElementById('ptcmp');
    if (!root || root.dataset.ready === 'true') return;
    const sticky = root.querySelector('[data-mobile-cta]');
    const hero = root.querySelector('.hero');
    const cta = root.querySelector('.cta');
    if (!sticky || !hero || !cta) return;
    root.dataset.ready = 'true';
    let queued = false;
    const update = () => {
      queued = false;
      const show = hero.getBoundingClientRect().bottom < 0 && cta.getBoundingClientRect().top > window.innerHeight;
      sticky.classList.toggle('show', show);
      sticky.setAttribute('aria-hidden', String(!show));
      sticky.inert = !show;
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();